import moment from 'moment';
import { EMARPOLDocuments, TMARPOLTank } from '../../marpol/@types';
import {
    ECRBRecordCode,
    ECRBRecordState,
    TCRBCommonData,
    TCRBCommonFields,
    ESubstanceCategories,
} from '../@types';

export type TCRBWashingPlace =
    | {
          place: 'AT_SEA';
          startPosition: { latitude: string; longitude: string };
          endPosition: { latitude: string; longitude: string };
      }
    | {
          place: 'AT_RECEPTION_FACILITY';
          receiptNumber: string;
          receiptAttachment: string;
          portName: string;
          receptionFacilityName: string;
      }
    | {
          place: 'TO_TANK';
          tanks: TCRBDestinationTank[];
      };

export type TCRBDestinationTank = {
    selectedTank: TMARPOLTank;
    transferQuantity: number;
    newQuantity: number;
    substance: string;
    catgeory: ESubstanceCategories;
};

export type TCRBItem15 = {
    tanks: TCRBItem15Tank[];
};

export type TCRBItem15Tank = {
    selectedTank: TMARPOLTank;
    transferQuantity: number;
    newQuantity: number;
    substance: string;
    catgeory: ESubstanceCategories;
};

export type TCRBItem15P1 = {
    procedure: string;
    cleaningAgents: string;
    ventilationProcedure: string;
};

export type TCRBItem15P2 = {
    startDate: string;
    startTime: string;
    endDate: string;
    endTime: string;
};

export type TCRBItem15P3 = {
    totalTransferQuantity: number;
};

export type TCRBItem16 = {
    transfer: TCRBWashingPlace;
};

export type TCRBE1 = TCRBCommonFields &
    TCRBCommonData & {
        id: string;
        recordCode: ECRBRecordCode.CRBE;
        item15: TCRBItem15;
        item15P1: TCRBItem15P1;
        item15P2: TCRBItem15P2;
        item15P3: TCRBItem15P3;
        item16: TCRBItem16;
    };

export type TCRBE = TCRBE1;

const CRBE_DEFAULTS: {
    E: TCRBE1;
} = {
    E: {
        id: '',
        _rev: '',
        marpolType: EMARPOLDocuments.CRB,
        state: ECRBRecordState.IDLE,
        selectedDate: moment().format('YYYY-MM-DD'),
        remarks: '',
        item15: {
            tanks: [],
        },
        item15P1: {
            procedure: '',
            cleaningAgents: '',
            ventilationProcedure: '',
        },
        item15P2: {
            startDate: '',
            endDate: '',
            startTime: '',
            endTime: '',
        },
        item15P3: {
            totalTransferQuantity: 0,
        },
        item16: {
            transfer: {
                place: 'AT_SEA',
                startPosition: {
                    latitude: '',
                    longitude: '',
                },
                endPosition: {
                    latitude: '',
                    longitude: '',
                },
            },
        },

        recordCode: ECRBRecordCode.CRBE,
    },
};

export { CRBE_DEFAULTS };
